exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Cloze-PassageTile{display:inline-block;text-align:left;max-width:160px;border:1px solid #aaa;border-radius:5px;padding-top:10px;padding-bottom:10px}.Cloze-PassageTile>div{padding-left:10px;padding-right:10px}.Cloze-PassageTile .title{font-style:italic}.Cloze-PassageTile .category,.Cloze-PassageTile .subCategory{font-size:.8em;margin-top:10px}.Cloze-PassageTile .category{border-top:1px solid #ccc;padding-top:10px}.Cloze-PassageTile img.icon{height:auto;vertical-align:middle;width:26px;margin-top:-13px;margin-bottom:-9px;margin-right:3px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/cloze/passage_tile.scss
// module id = 1286
// module chunks = 0